import { FEATURES } from '/src/features/_global/constants';

export const SSO_PERMISSIONS = {
  [FEATURES.SSO]: ({ capabilities }) => ({
    navigate: capabilities?.sso.permissions.nav,
    edit: capabilities?.sso.permissions.edit,
  }),
};
